import React, { useContext } from "react";
import { SidebarContext } from "../../context/SidebarContext";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./Referrals.css";
import { useState } from "react";
import { config } from "../../config.js";
import { useEffect } from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { useMemo } from "react";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import { LuArrowLeft } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function Referrals() {
    const navigate = useNavigate()
  const { isSidebar } = useContext(SidebarContext);
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = localStorage.getItem("adminRole");
  const adminCity =
    role === "sub-admin" ? localStorage.getItem("adminCity") : null;
  const [showModal, setShowModal] = useState(false);
  const [selectedReferrals, setSelectedReferrals] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState("");
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [commission, setCommission] = useState("");
  const [isComLoading, setIsComLoading] = useState(false);

  const fetchCommission = async () => {
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}referrals/commission`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      if (result.status) {
        setCommission(result.commission);
      } else {
        setCommission(0);
      }
    } catch (error) {
      console.error("Fetching Referrals failed:", error);
      setCommission("");
    }
  };

  const fetchReferrals = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}referrals${adminCity ? `?adc=${adminCity.toLocaleLowerCase()}` : ""}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setReferrals(result.data);
      } else {
        setReferrals([]);
      }
    } catch (error) {
      console.error("Fetching Referrals failed:", error);
      setReferrals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferrals();
    fetchCommission();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "userName",
        header: "Driver",
      },
      {
        accessorKey: "referralCode",
        header: "Referral Code",
      },
      {
        accessorKey: "referralWalletBalance",
        header: "Wallet Balance",
      },
      {
        accessorKey: "referralMaxClaims",
        header: "Max Claims",
      },
      {
        accessorKey: "referralClaimedCount",
        header: "Claimed",
      },
      {
        header: "Referrals",
        Cell: ({ row }) => (
          <button
            className="view-referral-btn"
            onClick={() => {
              setSelectedReferrals(row.original.referrals || []);
              setSelectedDriver(row.original.userName);
              setShowModal(true);
            }}
          >
            View ({row.original.referralCount})
          </button>
        ),
      },
    ],
    [],
  );

  const referralDetailColumns = useMemo(
    () => [
      { header: "#", Cell: ({ row }) => row.index + 1 },
      { accessorKey: "userName", header: "Name" },
      { accessorKey: "referenceMobile", header: "Mobile" },
    ],
    [],
  );

  const handleSaveCommission = async () => {
    setIsComLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}referrals/commission`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify({
            commission: commission,
          }),
        },
      );

      const result = await response.json();

      if (result.status) {
        toast.success("Commission updated successfully");
        setShowCommissionModal(false);
        setCommission(commission);
      } else {
        toast.error(result.message || "Failed to update commission");
      }
    } catch (error) {
      console.error("Commission update failed:", error);
    } finally {
      setIsComLoading(false);
      // fetchCommission()
    }
  };

  //  Skeleton Loader
  const SkeletonLoader = () => (
    <div className="skeleton-wrapper">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="skeleton-row">
          <div className="skeleton-cell long"></div>
          <div className="skeleton-cell small"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell medium"></div>
          <div className="skeleton-cell short"></div>
          <div className="skeleton-cell small"></div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className="body">
        <div id="wrapper">
          <div id="page">
            <div className="layout-wrap">
              <SectionMenuLeft />
              <div className="section-content-right">
                <div
                  className="main-content"
                  style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
                >
                  <div className="main-content-inner">
                    <div className="main-content-wrap">
                      <div className="tf-section">
                        <div
                          className="wg-box"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                              <div className="flex items-center gap-3">
                                <button
                                  className="back-btn flex items-center gap-2"
                                  onClick={() => navigate("/")}
                                >
                                  <LuArrowLeft size={16} />
                                  {/* <span>Back</span> */}
                                </button>

                                <h5 className="fare-heading">
                                  Referrals Overview
                                </h5>
                              </div>
                            </div>
                            <button
                              className="btn btn-success"
                              onClick={() => setShowCommissionModal(true)}
                            >
                              Set Admin Commission
                            </button>
                          </div>

                          {/*  Show Skeleton or Table */}
                          {loading ? (
                            <SkeletonLoader />
                          ) : (
                            <ReactTable columns={columns} data={referrals} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h4>{selectedDriver} - Referrals</h4>
              <button onClick={() => setShowModal(false)}>✕</button>
            </div>

            <ReactTable columns={referralDetailColumns} data={selectedReferrals} />
          </div>
        </div>
      )}
      {showCommissionModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content shadow-lg">
              <div className="modal-header">
                <h5 className="modal-title">Set Referral Commission</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCommissionModal(false)}
                >
                  <RxCross2 />
                </button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Commission (%)</label>
                  <input
                    type="number"
                    className="form-control com-inp"
                    placeholder="Enter commission percentage"
                    value={commission}
                    onChange={(e) => setCommission(e.target.value)}
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-dark"
                  onClick={() => setShowCommissionModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={handleSaveCommission}
                  disabled={isComLoading}
                >
                  {isComLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Referrals;
